export enum LockerStatus {
    PENDING = "Non configurato",
    CONFIGURED = "Configurato"
}
